import Colors from '@/constants/Colors';
import styled from 'styled-components';

export const StyledTextWithTranslations = styled.div`
  .clickable-word {
    cursor: pointer;
    //text-decoration: underline;
    font-weight: bold;
    color: ${Colors.darkBlue};
  }
`;
